import { createSlice } from '@reduxjs/toolkit'
import { CryptoUtils } from 'src/utils/Crypto.utils'
import { ResponseDataBody, SvcLocationType } from 'src/types/websocket'

const initialState: ResponseDataBody.LocationHistory = {
  LocationInfos: [],
}

const LocationHistorySlice = createSlice({
  name: 'locationHistory',
  initialState,
  reducers: {
    setLocationInfos(state, action) {
      state.LocationInfos = action.payload?.LocationInfos?.map((d: SvcLocationType) => {
        const x = CryptoUtils.DecryptData(d.XVal)
        const y = CryptoUtils.DecryptData(d.YVal)
        const address = CryptoUtils.DecryptData(d.Address)
        return { ...d, XVal: x, YVal: y, Address: address }
      })
    },
  },
})

export const { setLocationInfos } = LocationHistorySlice.actions

export default LocationHistorySlice.reducer
